export default __webpack_public_path__ + "static/media/detail_big_10_4.f6713494.jpg";